export enum BackgroundTaskType {
  UploadingGricsFiles = 'uploading-grics-file',
  DownloadAllReports = 'download-all-reports',
  MassEmailUpdate = 'mass-email-update',
}
